import { IconStore } from '../../../IconStore';

function formatForecastPct(forecastValue, portfolioValue) {
  if (typeof forecastValue !== 'number' || typeof portfolioValue !== 'number' || !portfolioValue) {
    return null;
  }
  const percentChange = ((forecastValue - portfolioValue) / portfolioValue) * 100;
  const prefix = percentChange >= 0 ? '+' : '';
  return `${prefix}${percentChange.toFixed(2)}% vs current`;
}

function ForecastCard(props) {
  const formatter = Intl.NumberFormat();
  const textStyle = {
    marginBottom: 0
  };
  const subTextStyle = {
    fontSize: 14,
    verticalAlign: 'top'
  };
  const displayForecast = typeof props.oneYearForecast === 'number'
    ? `$${formatter.format(Math.round(props.oneYearForecast))}`
    : '—';
  const displayPercentChange = formatForecastPct(props.oneYearForecast, props.portfolioValue);

  return (
    <div className="card border-light shadow-sm card-metric">
      <div className="card-body">
        <div className="row d-block d-xl-flex align-items-center">
          <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
            <div className="icon icon-shape icon-md icon-shape-blue rounded mr-4">
              <span className={'fas ' + IconStore.forecast}></span>
            </div>
            <div className="d-sm-none">
              <h2 className="h5" style={textStyle}>1 Year Forecast</h2>
              <h3 className="mb-1">{displayForecast}</h3>
              {displayPercentChange && (
                <span className="text-muted" style={subTextStyle}>{displayPercentChange}</span>
              )}
            </div>
          </div>
          <div className="col-12 col-xl-7 px-xl-0">
            <div className="d-none d-sm-block">
              <h2 className="h5" style={textStyle}>1 Year Forecast</h2>
              <h3 className="mb-1">{displayForecast}</h3>
              {displayPercentChange && (
                <span className="text-muted" style={subTextStyle}>{displayPercentChange}</span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForecastCard;
